import { useParams, Navigate } from 'react-router-dom';
import ProductDetailPage from './ProductDetailPage';
import { extractIdFromSlug } from '../lib/productUrl';

/**
 * Router adapter for the SEO URL `/location-{slug-name}-{id}`.
 *
 * React Router 7 does NOT support partial dynamic segments like
 * `location-:slug`, so we register this component under a single-segment
 * dynamic route (`path=":productSlug"`) and manually check the prefix +
 * extract the trailing numeric id here.
 *
 * Non-matching segments fall through to a benign redirect to home so we
 * don't render a broken product page.
 */
const ProductBySlug = () => {
  const { productSlug } = useParams();
  if (!productSlug || !productSlug.startsWith('location-')) {
    return <Navigate to="/" replace />;
  }
  const id = extractIdFromSlug(productSlug);
  if (!id) {
    return <Navigate to="/" replace />;
  }
  // Re-use the ProductDetailPage — it accepts either useParams id or slug.
  return <ProductDetailPage />;
};

export default ProductBySlug;
